/* Royal Players' Hub · FA Full-Time feeds (league table + team fixtures/results):
   restyle, highlight us, home summary. Static theme content stays as fallback. */
(function () {
  var root = document.getElementById('rph'); if (!root) return;
  var ft = root.querySelector('#rph-ft'); if (!ft) return;
  var US = /royal\s*parthenope/i;
  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function esc(v) { return String(v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function $$(s, el) { return [].slice.call(el.querySelectorAll(s)); }

  /* every feed after the first one (the league table) goes to the Fixtures tab */
  var feeds = $$('div[id^="lrep"]', ft), fxBox = null;
  if (feeds.length > 1) {
    var card = root.querySelector('[data-subpanel="fixtures"] .card');
    if (card) {
      card.innerHTML = '<div class="k">FIXTURES &amp; RESULTS</div>';
      fxBox = document.createElement('div'); fxBox.className = 'ft ft-fx'; fxBox.id = 'rph-fx'; card.appendChild(fxBox);
      var src = document.createElement('p'); src.className = 'ft-src'; src.textContent = 'Live from FA Full-Time.'; card.appendChild(src);
      feeds.slice(1).forEach(function (d) { fxBox.appendChild(d); });
    }
  }

  function clean(box, t) {
    $$('a', box).forEach(function (a) {
      if (/full-time/i.test(a.textContent) || /thefa\.com\/FULL-TIME/i.test(a.getAttribute('href') || '')) { a.remove(); return; }
      var s = document.createElement('span'); s.textContent = a.textContent; a.replaceWith(s);
    });
    $$('[style],[bgcolor],[width],[border],[cellpadding],[cellspacing]', t).concat([t]).forEach(function (el) {
      ['style', 'bgcolor', 'width', 'border', 'cellpadding', 'cellspacing'].forEach(function (a) { el.removeAttribute(a); });
    });
    $$('colgroup,col', t).forEach(function (c) { c.remove(); });
  }
  /* header labels expanded by colspan, so column i of a data row maps to header i */
  function heads(r) {
    var out = [];
    [].slice.call(r.children).forEach(function (c) { out.push(txt(c)); for (var k = 1; k < (c.colSpan || 1); k++) out.push(''); });
    return out;
  }
  function when(box, fn) {
    var n = 0, iv = setInterval(function () {
      var t = box.querySelector('table'); n++;
      if (t) { clearInterval(iv); clean(box, t); fn(t); }
      else if (n > 40) { clearInterval(iv); fn(null); }
    }, 400);
  }

  /* league table */
  when(ft, function (t) {
    var mini = root.querySelector('#rph-ft-mini');
    if (!t) { if (mini) mini.innerHTML = '<p class="s">Table not available right now.</p>'; return; }
    var trs = $$('tr', t);
    var head = trs.filter(function (r) { return [].slice.call(r.children).some(function (c) { return /^pts$/i.test(txt(c)); }); })[0];
    var hc = head ? heads(head) : [];
    var iPts = hc.indexOf ? hc.map(function (x) { return x.toLowerCase(); }).indexOf('pts') : -1;
    var teams = [];
    trs.forEach(function (r) {
      var c = [].slice.call(r.children);
      if (r === head) { r.classList.add('hd'); return; }
      if (!/^\d+$/.test(txt(c[0] || r))) { r.classList.add('ft-x'); return; }
      teams.push(r); if (US.test(txt(r))) r.classList.add('us');
      c[0].classList.add('c-pos'); if (c[1]) c[1].classList.add('c-team');
      var p = iPts > -1 && c[iPts] ? c[iPts] : c[c.length - 1]; if (p) p.classList.add('c-pts');
      c.forEach(function (cell, i) { if (/^(w|d|l|f|a)$/i.test(hc[i] || '')) cell.classList.add('c-x'); });
    });
    if (head) {
      var hcells = [].slice.call(head.children);
      if (hcells[0] && (hcells[0].colSpan || 1) < 2 && teams[0] && teams[0].children.length > hcells.length) hcells[0].colSpan = 2;
      hcells.forEach(function (c) { if (/^(w|d|l|f|a)$/i.test(txt(c))) c.classList.add('c-x'); if (/^pts$/i.test(txt(c))) c.classList.add('c-pts'); });
    }
    if (!mini) return;
    function cells(r) { var c = [].slice.call(r.children); return { pos: txt(c[0]), team: txt(c[1] || c[0]), pts: txt(r.querySelector('.c-pts') || c[c.length - 1]) }; }
    var mine = teams.filter(function (r) { return r.classList.contains('us'); })[0];
    var html = '';
    if (mine) { var me = cells(mine); html += '<div class="lt-pos">' + esc(me.pos) + '<small>of ' + teams.length + ' · ' + esc(me.pts) + ' pts</small></div>'; }
    var pick = teams.slice(0, 4); if (mine && pick.indexOf(mine) < 0) pick.push(mine);
    html += '<table class="lt-mini"><tbody>' + pick.map(function (r) {
      var c = cells(r);
      return '<tr' + (r === mine ? ' class="me"' : '') + '><td class="c-pos">' + esc(c.pos) + '</td><td>' + esc(c.team) + '</td><td class="n">' + esc(c.pts) + '</td></tr>';
    }).join('') + '</tbody></table>';
    mini.innerHTML = html;
  });

  /* parse the FA team feed into plain fixtures, shared with the live layer (Match Centre import) */
  var MON = { jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6, jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12 };
  function p2(n) { return (n < 10 ? '0' : '') + n; }
  function parseFx(t) {
    var out = [], VEN = /park|ground|field|powerleague|centre|center|school|road|lane|rec\b|stadium|pitch|common/i;
    $$('tr', t).forEach(function (r) {
      var c = [].slice.call(r.children).map(txt); if (c.length < 3 || !US.test(c.join(' '))) return;
      var all = c.join(' '), m, y, mo, d, time = '';
      if ((m = all.match(/(\d{1,2})\/(\d{1,2})\/(\d{2,4})/))) { d = +m[1]; mo = +m[2]; y = +m[3]; }
      else if ((m = all.match(/(\d{1,2})(?:st|nd|rd|th)?\s+([A-Za-z]{3})[a-z]*\.?\s+(\d{2,4})/)) && MON[m[2].toLowerCase()]) { d = +m[1]; mo = MON[m[2].toLowerCase()]; y = +m[3]; }
      else return;
      if (y < 100) y += 2000;
      if ((m = all.match(/\b(\d{1,2})[:.](\d{2})\b/))) time = p2(+m[1]) + ':' + m[2];
      var si = -1, score = null;
      c.forEach(function (x, i) { if (si > -1) return; if (/^(v|vs|v\.)$/i.test(x)) si = i; var k = x.match(/^(\d+)\s*[-–:]\s*(\d+)$/); if (k) { si = i; score = [+k[1], +k[2]]; } });
      var home = '', away = '', rest = [];
      if (si > 0) {
        for (var i = si - 1; i >= 0; i--) if (/[A-Za-z]{3}/.test(c[i]) && !/\d{1,2}\/\d{1,2}/.test(c[i])) { home = c[i]; break; }
        for (var j = si + 1; j < c.length; j++) if (/[A-Za-z]{3}/.test(c[j])) { away = c[j]; rest = c.slice(j + 1); break; }
      } else {
        var hit = c.filter(function (x) { return /\s(v|vs)\s/i.test(x); })[0]; if (!hit) return;
        var pp = hit.split(/\s+(?:v|vs)\s+/i); home = pp[0]; away = pp[1] || ''; rest = c.slice(c.indexOf(hit) + 1);
      }
      var weHome = US.test(home), opp = (weHome ? away : home).replace(/\s+/g, ' ').trim();
      if (!opp || US.test(opp)) return;
      rest = rest.filter(function (x) { return x && /[A-Za-z]/.test(x) && !US.test(x); });
      out.push({ day: y + '-' + p2(mo) + '-' + p2(d), time: time, opp: opp, home: weHome, score: score,
        venue: rest.filter(function (x) { return VEN.test(x); })[0] || '', comp: rest.filter(function (x) { return !VEN.test(x); })[0] || '' });
    });
    return out;
  }

  /* team fixtures & results */
  if (fxBox) when(fxBox, function (t) {
    if (!t) { fxBox.innerHTML = '<p class="s">Fixtures not available right now.</p>'; return; }
    try { window.RPH_FA_FX = parseFx(t); document.dispatchEvent(new CustomEvent('rph:fa', { detail: window.RPH_FA_FX })); } catch (e) {}
    $$('tr', t).forEach(function (r) {
      var c = [].slice.call(r.children);
      if (r.querySelector('th') || c.every(function (x) { return x.tagName === 'TH'; })) { r.classList.add('hd'); return; }
      if (c.length < 2) { r.classList.add('fx-sep'); return; }
      /* score cells like "3 - 2" get the display face */
      c.forEach(function (cell) { if (/^\s*\d+\s*[-–:]\s*\d+\s*$/.test(txt(cell))) cell.classList.add('c-score'); });
      if (US.test(txt(r))) r.classList.add('fx-us');
    });
  });
})();
